import React from 'react';


const PaymentView = ({ type }) => {
  const typeList = {
    itunes_ppd: 'iTunes',
    paymaster: 'PayMaster',
    inplat: 'SMS',
    kievstar: 'Kievstar',
    inplatmk: 'SMS',
    payonline_trial: 'PayOnline Trial',
    credit_card: 'Банковская карта',
    svyaznoy: 'Платная SMS',
    itunes: 'iTunes',
    yandex: 'Яндекс.Деньги',
    webmoney: 'WebMoney',
    gift: 'Подарочный код',
    'google-play': 'Google Play',
    yandexmoney: 'YandexMoney',
    qiwi: 'QIWI',
    paypal: 'PayPal',

  };
  return (
    <React.Fragment>
      <div>{typeList[type]}</div>
    </React.Fragment>
  );
};

export default PaymentView;


